/**
 * Machine lifecycle status — canonical asset_tracking values, display labels
 * and MUI chip colors. Stored values stay backward compatible with existing
 * queries (RENTAL / AVAILABLE / SERVICE).
 */
export const STATUS_LABELS = {
    RENTAL: 'On Rent',
    DE_HIRED: 'De-hired',
    SERVICE: 'On Service',
    BREAKDOWN: 'Breakdown',
    AVAILABLE: 'Ready for Rent',
    WAITING_FOR_RENT: 'Waiting for Rent',
    MAINTENANCE: 'On Service', // legacy value, same bucket as SERVICE
    // Internal / non-fleet states — never touch rental or service workflows.
    TESTING: 'Testing',
    SALE: 'For Sale',
    UNKNOWN: 'Unknown',
};

export const STATUS_COLORS = {
    RENTAL: 'primary',
    DE_HIRED: 'secondary',
    SERVICE: 'warning',
    BREAKDOWN: 'error',
    AVAILABLE: 'success',
    WAITING_FOR_RENT: 'info',
    MAINTENANCE: 'warning',
    TESTING: 'secondary',
    SALE: 'default',
    UNKNOWN: 'default',
};

// Statuses a machine can be moved to from the change-status dialog.
// TESTING / SALE are internal-only lifecycle tags for parked machines; they
// create no service ticket and no rental contract, and are excluded from the
// rental fleet and service queues (those filter on RENTAL / service statuses).
export const MACHINE_STATUSES = ['RENTAL', 'DE_HIRED', 'SERVICE', 'BREAKDOWN', 'AVAILABLE', 'WAITING_FOR_RENT', 'TESTING', 'SALE'];

export const statusLabel = (raw) => {
    if (!raw) return 'Unknown';
    const key = String(raw).toUpperCase().replace(/\s+/g, '_');
    return STATUS_LABELS[key] || (raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase());
};

export const statusColor = (raw) => {
    if (!raw) return 'default';
    const key = String(raw).toUpperCase().replace(/\s+/g, '_');
    return STATUS_COLORS[key] || 'default';
};
